import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor } from "./Accessor";
export var AnonymousAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(AnonymousAccessor, _Accessor);

  function AnonymousAccessor(buildSharedQuery) {
    var _this;

    _classCallCheck(this, AnonymousAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnonymousAccessor).call(this));

    if (buildSharedQuery) {
      _this.buildSharedQuery = buildSharedQuery;
    }

    return _this;
  }

  return AnonymousAccessor;
}(Accessor);